import axios from 'axios'

const API_URL = process.env.VUE_APP_API_SUPPORT_URL
class CategoryService {
  getcategoryList() {
    return axios.get(API_URL + '/category/published')
  }
}

export default new CategoryService()
